module.exports = __webpack_public_path__ + "static/img/szafa_12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_12.jpg
// module id = HY/k
// module chunks = 0